import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  TextField,
  Tooltip,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";

const PersonalForm = ({
  handleSave,
  handleChange,
  formData,
  errors,
  hasChanges,
}) => {
  return (
    <Box p={2}>
      <Card variant="outlined" sx={{ borderRadius: 5 }}>
        <CardContent>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography sx={{ fontWeight: "bold" }} variant="h6">
              Personal Details
            </Typography>
            <Box>
              {hasChanges && (
                <Box display="flex" justifyContent="flex-end" mb={2}>
                  <Button
                    onClick={handleSave}
                    startIcon={<SaveIcon />}
                    variant="contained"
                    color="primary"
                  >
                    Save
                  </Button>
                </Box>
              )}
            </Box>
          </Box>

          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <Box>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: errors.ownerName ? "#d32f2f" : "inherit",
                  }}
                  gutterBottom
                >
                  Full Name *
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  name="ownerName"
                  value={formData.ownerName}
                  onChange={handleChange}
                  error={!!errors.ownerName}
                  helperText={errors.ownerName}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: errors.emailAddress ? "#d32f2f" : "inherit",
                  }}
                  gutterBottom
                >
                  Email Address *
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  name="emailAddress"
                  value={formData.emailAddress}
                  onChange={handleChange}
                  error={!!errors.emailAddress}
                  helperText={errors.emailAddress}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: errors.ownerPrimaryContactNo ? "#d32f2f" : "inherit",
                  }}
                  gutterBottom
                >
                  Primary Contact Number *
                </Typography>
                <TextField
                  fullWidth
                  name="ownerPrimaryContactNo"
                  variant="outlined"
                  size="small"
                  value={formData.ownerPrimaryContactNo}
                  onChange={handleChange}
                  error={!!errors.ownerPrimaryContactNo}
                  helperText={errors.ownerPrimaryContactNo}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: errors.ownerSecondaryContactNo
                      ? "#d32f2f"
                      : "inherit",
                  }}
                  gutterBottom
                >
                  Secondary Contact Number
                </Typography>
                <TextField
                  fullWidth
                  value={formData.ownerSecondaryContactNo}
                  variant="outlined"
                  size="small"
                  name="ownerSecondaryContactNo"
                  onChange={handleChange}
                  error={!!errors.ownerSecondaryContactNo}
                  helperText={errors.ownerSecondaryContactNo}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box>
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontWeight: 600,
                    color: errors.aadhaarCardNumber ? "#d32f2f" : "inherit",
                  }}
                  gutterBottom
                >
                  Aadhar Card Number
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={formData.aadhaarCardNumber}
                  name="aadhaarCardNumber"
                  onChange={handleChange}
                  error={!!errors.aadhaarCardNumber}
                  helperText={errors.aadhaarCardNumber}
                />
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PersonalForm;
